<template>
  <a-modal
    :maskClosable="false"
    :title="modalTitle"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    :okButtonProps="{ props: { disabled: disabled } }"
    @ok="handleSubmit"
    @cancel="visible = false"
  >
    <a-form layout="horizontal" :form="form" @submit="handleSubmit">
      <a-form-item
        v-if="orgType == 2"
        label="学校"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 8 } }"
      >
        <a-select
          :showSearch="true"
          :showArrow="false"
          labelInValue
          placeholder="搜索学校"
          style="width: 100%"
          :filterOption="false"
          @search="fetch"
          @change="searchChange"
          :notFoundContent="fetching ? undefined : null"
          v-decorator="['schoolId', { rules: [{ required: true, message: '请选择学校' }] }]"
        >
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in data" :key="d.value" :value="d.value">{{
            d.text
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        v-if="orgType == 3"
        label="课程方"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 8 } }"
      >
        <a-select
          :showSearch="true"
          :showArrow="false"
          labelInValue
          placeholder="搜索课程方"
          style="width: 100%"
          :filterOption="false"
          @search="fetch"
          @change="searchChange"
          :notFoundContent="fetching ? undefined : null"
          v-decorator="['institutionId', { rules: [{ required: true, message: '请选择课程方' }] }]"
        >
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in data" :key="d.value">{{ d.text }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="活动类型"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 8 } }"
      >
        <a-select
          class="form-cell"
          placeholder="请选择活动类型"
          :disabled="disabled"
          v-decorator="['classifyId', { rules: [{ required: true, message: '请选择活动类型' }] }]"
        >
          <a-select-option v-for="(item, index) in tags" :value="item.id" :key="index">{{
            item.tagName
          }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="活动标题"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 8 } }"
      >
        <a-input
          type="text"
          v-decorator="['title', { rules: [{ required: true, message: '请输入活动标题' }] }]"
          :disabled="disabled"
        />
      </a-form-item>

      <a-form-item
        label="活动地址"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 18 } }"
      >
        <a-cascader
          :options="$store.state.common.address"
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          placeholder="请选择省市区"
          :disabled="disabled"
          v-decorator="['addressIds', { rules: [{ required: true, message: '请选择省市区' }] }]"
        />
      </a-form-item>

      <a-form-item
        label="详细地址"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 18 } }"
      >
        <a-input
          type="text"
          placeholder="详细地址"
          :disabled="disabled"
          v-decorator="[
            'detailAddress',
            { rules: [{ required: true, message: '请填写详细地址' }] },
          ]"
        />
      </a-form-item>

      <a-form-item
        label="地点名称"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 18 } }"
      >
        <a-input
          type="text"
          placeholder="地点名称"
          :disabled="disabled"
          v-decorator="['location', { rules: [{ required: true, message: '请填写地点名称' }] }]"
        />
      </a-form-item>

      <a-form-item
        label="地点经纬度"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 10 } }"
      >
        <a-input
          type="text"
          placeholder="请选择填写经纬度"
          :disabled="disabled"
          v-decorator="['lngLat', { rules: [{ required: true, message: '请填写经纬度' }] }]"
        />
        <a href="https://lbs.amap.com/console/show/picker" target="_blank">点击这里获取经纬度</a>
      </a-form-item>

      <a-form-item
        label="活动时间"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 20 } }"
      >
        <a-range-picker
          :disabledDate="disabledDate"
          :disabledTime="disabledRangeTime"
          :showTime="{
            hideDisabledOptions: true,
            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
          }"
          format="YYYY-MM-DD HH:mm:ss"
          :disabled="disabled"
          v-decorator="['time', { rules: [{ required: true, message: '请填选择活动时间' }] }]"
        />
      </a-form-item>

      <a-form-item
        label="封面图"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 20 } }"
        :required="true"
        :help="coverUrlHelpTxt"
        validateStatus="error"
      >
        <c-upload
          ref="coverUrl"
          :sourceFileList="sourceFileList"
          :ossType="'activity'"
          :isSingle="false"
          @uploadSuccess="uploadSuccess"
        ></c-upload>
      </a-form-item>

      <a-form-item
        label="活动介绍"
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 20 } }"
      >
        <c-richtext :editorContent.sync="editorContent"></c-richtext>
      </a-form-item>

      <a-form-item
        :labelCol="{ lg: { span: 4 } }"
        :wrapperCol="{ lg: { span: 20 } }"
        v-for="(k, index) in form.getFieldValue('keys')"
        :key="k"
        :label="index === 0 ? '费用' : ' '"
        :colon="index === 0 ? true : false"
        :required="index === 0 ? true : false"
        style="margin-bottom: 0 !important"
      >
        <a-row :gutter="8">
          <a-col :span="6">
            <a-form-item
              :colon="false"
              label="名称"
              :labelCol="{ lg: { span: 12 } }"
              :wrapperCol="{ lg: { span: 12 } }"
              :required="false"
              style="margin-bottom: 0 !important"
            >
              <a-input
                type="text"
                placeholder="名称"
                :disabled="disabled"
                style="width: 90px"
                v-decorator="[
                  `priceDesc[${k}]`,
                  {
                    rules: [
                      { required: true, max: 10, message: '请填写费用名称且不能超过10个字符' },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              :colon="false"
              label="金额"
              :labelCol="{ lg: { span: 12 } }"
              :wrapperCol="{ lg: { span: 12 } }"
              style="margin-bottom: 0 !important"
            >
              <a-input-number
                :min="0"
                :formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\￥\s?|(,*)/g, '')"
                :disabled="disabled"
                v-decorator="[
                  `price[${k}]`,
                  { initialValue: 0 },
                  { rules: [{ required: true, min: 0, message: '请填金额' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              :colon="false"
              label="名额"
              :labelCol="{ lg: { span: 12 } }"
              :wrapperCol="{ lg: { span: 12 } }"
              style="margin-bottom: 0 !important"
            >
              <a-input-number
                :min="0"
                :disabled="disabled"
                v-decorator="[
                  `numMax[${k}]`,
                  { initialValue: 0 },
                  { rules: [{ required: true, min: 0, message: '请填名额数' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col v-if="disabled == false" :span="6">
            <a-icon
              v-if="form.getFieldValue('keys').length > 1"
              type="minus-circle-o"
              :disabled="form.getFieldValue('keys').length === 1"
              @click="() => removePrice(k)"
            />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item :wrapperCol="{ span: 21, offset: 4 }">
        <a-button
          type="dashed"
          style="width: 22%; margin-left: 3%"
          @click="addPrice"
          :disabled="disabled"
        >
          <a-icon type="plus" />添加费用项目
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import activity from '../../api/activity'
import moment from 'moment'
import CRichtext from '../../components/CRichtext/CRichtext'
import notification from 'ant-design-vue/es/notification'
import CUpload from '../../components/CUpload/CUpload'
import { v1 as uuidv1 } from 'uuid'

function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  name: 'activityForm',
  components: { CRichtext, CUpload },
  data() {
    return {
      tags: [],
      modalTitle: '',
      type: '',
      id: -1,
      orgType: null,
      visible: false,
      confirmLoading: false,
      disabled: false, //是否禁止编辑
      coverUrl: '', //封面图
      editorContent: '', //编辑器内容
      sourceFileList: [],
      coverUrlHelpTxt: '',
      data: [],
      value: [],
      fetching: false,
    }
  },
  methods: {
    moment,
    //初始化，显示
    init(type, params) {
      this.id = params.id
      this.type = type
      this.orgType = params.orgType
      this.visible = true
      let id = this.id
      //获取活动类型
      this.tags = this.$store.state.common.tags.filter(item => item.tagGroup == 3)
      //获取详情
      if (this.type == 'add') {
        this.disabled = false
        this.modalTitle = '新增活动'
        this.form.resetFields()
        setTimeout(() => {
          this.sourceFileList = []
          this.editorContent = ''
        }, 100)
      }
      //获取详情
      if (this.type == 'edit') {
        this.disabled = false
        this.modalTitle = '修改活动'
        this.getDetail(id)
      }
      if (this.type == 'detail') {
        this.disabled = true
        this.modalTitle = '详情'
        this.getDetail(id)
      }
    },
    fetch(value) {
      if (this.orgType != 1) {
        console.log('fetching', value)
        this.data = []
        this.fetching = true
        if (this.orgType == 2) {
          let schoolName = value
          activity.searchSchool({ schoolName }).then(res => {
            const data = res.data.map(item => ({
              text: item.schoolName,
              value: item.id + '',
            }))
            console.log(data)
            this.data = data
            this.fetching = false
          })
        }
        if (this.orgType == 3) {
          let institutionName = value
          activity.searchInstitution({ institutionName }).then(res => {
            const data = res.data.map(item => ({
              text: item.institutionName,
              value: item.id + '',
            }))
            this.data = data
            this.fetching = false
          })
        }
      }
    },
    searchChange(value) {
      Object.assign(this, {
        value,
        data: [],
        fetching: false,
      })
    },
    //提交
    handleSubmit(e) {
      e.preventDefault()
      if (this.coverUrl == '') {
        this.coverUrlHelpTxt = '请上传活动图片'
      }
      this.form.validateFields((err, values) => {
        console.log(values)
        //校验通过
        if (!err && this.coverUrlHelpTxt == '') {
          // let lngLat = values.lngLat ? values.lngLat.split(',') : ['', ''] 
          let reg = /[^0-9,.]/ 
          console.log(values.lngLat.search(reg),'哈哈哈哈哈')
          if(values.lngLat && values.lngLat.search(reg) >= 0){
            this.$error({title:'经纬度分隔符号请勿输入英文逗号外的其他符号'})
            return
          }
          let lngLat = values.lngLat ? values.lngLat.split(',') : ['', '']
          console.log(lngLat,'这块内容是什么')
          let prices = [] //费用
          if (values.numMax) {
            prices = values.numMax.map((value, key, arr) => {
              return {
                priceDesc: values.priceDesc[key] ? values.priceDesc[key] : '',
                price: (values.price[key] ? values.price[key] : 0) * 100,
                numMax: values.numMax[key] ? values.numMax[key] : 0,
              }
            })
          }
          let newValues = {
            classifyId: values.classifyId ? values.classifyId : '',
            title: values.title ? values.title : '',
            coverUrl: this.coverUrl,
            provinceId: values.addressIds ? values.addressIds[0] : '',
            cityId: values.addressIds ? values.addressIds[1] : '',
            districtId: values.addressIds ? values.addressIds[2] : '',
            detailAddress: values.detailAddress ? values.detailAddress : '', //详细地址
            location: values.location ? values.location : '', //地点名称
            lng: lngLat[0], //经度
            lat: lngLat[1], //纬度
            startTime: values.time ? values.time[0].toDate() : '', //开始时间
            endTime: values.time ? values.time[1].toDate() : '', //结束时间
            totalPrice: values.totalPrice ? values.totalPrice : 0, //活动总价格
            intro: this.editorContent, //活动介绍
            prices: JSON.stringify(prices), //费用
            // status: 0 //活动状态：0-待上架，1-上架中，2-已下架，3-已删除
          }
          if (this.orgType == 2) {
            newValues.schoolId = values.schoolId.key
          }
          if (this.orgType == 3) {
            newValues.institutionId = values.institutionId.key
          }
          if (this.type == 'add') {
            // newValues.orgType = this.orgType; //主办方类型：1-平台、2-公立学校、3-课程方；
            console.log(newValues)
            this.add(newValues)
          }
          if (this.type == 'edit') {
            this.edit(newValues)
          }
        }
      })
    },
    //新增
    add(params) {
      if (this.orgType == 1) {
        activity.sysAdd(params).then(res => {
          console.log('数据：', res)
          notification.success({
            message: '消息',
            description: '新增成功！',
          })
          let orgType = this.$parent.orgType
          let currentPage = this.$parent.pagination.current
          this.$parent.getActivityList({ orgType, currentPage })
          this.visible = false
        })
      }
      if (this.orgType == 2) {
        activity.schoolAdd(params).then(res => {
          console.log('数据：', res)
          notification.success({
            message: '消息',
            description: '新增成功！',
          })
          let orgType = this.$parent.orgType
          let currentPage = this.$parent.pagination.current
          this.$parent.getActivityList({ orgType, currentPage })
          this.visible = false
        })
      }
      if (this.orgType == 3) {
        activity.institutionAdd(params).then(res => {
          console.log('数据：', res)
          notification.success({
            message: '消息',
            description: '新增成功！',
          })
          let orgType = this.$parent.orgType
          let currentPage = this.$parent.pagination.current
          this.$parent.getActivityList({ orgType, currentPage })
          this.visible = false
        })
      }
    },
    //修改
    edit(params) {
      let id = this.id
      if (this.orgType == 1) {
        activity.sysUpdate(id, params).then(res => {
          console.log('数据：', res)
          notification.success({
            message: '消息',
            description: '修改成功！',
          })
          let orgType = this.$parent.orgType
          let currentPage = this.$parent.pagination.current
          this.$parent.getActivityList({ orgType, currentPage })
          this.visible = false
        })
      }
      if (this.orgType == 2) {
        activity.schoolUpdate(id, params).then(res => {
          console.log('数据：', res)
          notification.success({
            message: '消息',
            description: '修改成功！',
          })
          let orgType = this.$parent.orgType
          let currentPage = this.$parent.pagination.current
          this.$parent.getActivityList({ orgType, currentPage })
          this.visible = false
        })
      }
      if (this.orgType == 3) {
        activity.institutionUpdate(id, params).then(res => {
          console.log('数据：', res)
          notification.success({
            message: '消息',
            description: '修改成功！',
          })
          let orgType = this.$parent.orgType
          let currentPage = this.$parent.pagination.current
          this.$parent.getActivityList({ orgType, currentPage })
          this.visible = false
        })
      }
    },
    //获取详情
    getDetail(id) {
      if (this.orgType == 1) {
        activity.sysDetail({ id }).then(res => {
          console.log(res)
          let activityDO = res.data.activityDO
          let prices = res.data.prices
          let detail = {
            classifyId: activityDO.classifyId,
            title: activityDO.title,
            addressIds: [activityDO.provinceId, activityDO.cityId, activityDO.districtId],
            detailAddress: activityDO.detailAddress,
            location: activityDO.location,
            lngLat:
              (activityDO.lng ? activityDO.lng : '') + ',' + (activityDO.lat ? activityDO.lat : ''),
            time: [
              moment(activityDO.startTime, 'YYYY-MM-DD HH:mm:ss'),
              moment(activityDO.endTime, 'YYYY-MM-DD HH:mm:ss'),
            ],
          }
          this.editorContent = activityDO.intro ? activityDO.intro : ''
          this.form.setFieldsValue(detail)
          let keysArr = []
          let priceDesc = []
          let price = []
          let numMax = []
          if (prices) {
            for (let i in prices) {
              keysArr.push(i * 1)
              priceDesc.push(prices[i].priceDesc)
              price.push(prices[i].price / 100)
              numMax.push(prices[i].numMax)
            }
          }
          // let fileList=res.data.coverUrlList.map((item,i)=>{
          //   return {
          //     uid: this.getUuid(),
          //     name: i,
          //     url: item,
          //     relativeUrl: item,
          //   }
          // })
          // this.$refs.coverUrl.fileList=fileList;
          let coverUrl = ''
          let fileList = res.data.coverUrlList.map((item, index) => {
            if (index == 0) {
              coverUrl += item
            } else {
              coverUrl += ',' + item
            }
            return item
          })
          console.log('fileList', fileList)
          this.sourceFileList = fileList
          this.coverUrl = coverUrl

          //先设置动态增减表单的keys
          this.form.setFieldsValue({ keys: keysArr })
          //延时设置动态增减表单，防止渲染未完成设置失效
          setTimeout(() => {
            console.log(keysArr)
            this.form.setFieldsValue({ priceDesc, price, numMax })
          }, 100)
        })
      }
      if (this.orgType == 2) {
        activity.schoolDetail({ id }).then(res => {
          console.log(res)
          let activityDO = res.data.activityDO
          let prices = res.data.prices
          let detail = {
            classifyId: activityDO.classifyId,
            title: activityDO.title,
            addressIds: [activityDO.provinceId, activityDO.cityId, activityDO.districtId],
            detailAddress: activityDO.detailAddress,
            location: activityDO.location,
            lngLat:
              (activityDO.lng ? activityDO.lng : '') + ',' + (activityDO.lat ? activityDO.lat : ''),
            time: [
              moment(activityDO.startTime, 'YYYY-MM-DD HH:mm:ss'),
              moment(activityDO.endTime, 'YYYY-MM-DD HH:mm:ss'),
            ],
          }
          detail.schoolId = {
            key: res.data.schoolId + '',
            label: res.data.schoolName,
          }
          this.editorContent = activityDO.intro ? activityDO.intro : ''
          this.form.setFieldsValue(detail)
          let keysArr = []
          let priceDesc = []
          let price = []
          let numMax = []
          if (prices) {
            for (let i in prices) {
              keysArr.push(i * 1)
              priceDesc.push(prices[i].priceDesc)
              price.push(prices[i].price / 100)
              numMax.push(prices[i].numMax)
            }
          }
          let coverUrl = ''
          let fileList = res.data.coverUrlList.map((item, index) => {
            if (index == 0) {
              coverUrl += item
            } else {
              coverUrl += ',' + item
            }
            return item
          })
          console.log('fileList', fileList)
          this.sourceFileList = fileList
          this.coverUrl = coverUrl

          //先设置动态增减表单的keys
          this.form.setFieldsValue({ keys: keysArr })
          //延时设置动态增减表单，防止渲染未完成设置失效
          setTimeout(() => {
            console.log(keysArr)
            this.form.setFieldsValue({ priceDesc, price, numMax })
          }, 100)
        })
      }
      if (this.orgType == 3) {
        activity.institutionDetail({ id }).then(res => {
          console.log(res)
          let activityDO = res.data.activityDO
          let prices = res.data.prices
          let detail = {
            classifyId: activityDO.classifyId,
            title: activityDO.title,
            addressIds: [activityDO.provinceId, activityDO.cityId, activityDO.districtId],
            detailAddress: activityDO.detailAddress,
            location: activityDO.location,
            lngLat:
              (activityDO.lng ? activityDO.lng : '') + ',' + (activityDO.lat ? activityDO.lat : ''),
            time: [
              moment(activityDO.startTime, 'YYYY-MM-DD HH:mm:ss'),
              moment(activityDO.endTime, 'YYYY-MM-DD HH:mm:ss'),
            ],
          }
          detail.institutionId = {
            key: res.data.teaInstitutionId + '',
            label: res.data.teaInstitutionName,
          }
          this.editorContent = activityDO.intro ? activityDO.intro : ''
          this.form.setFieldsValue(detail)
          let keysArr = []
          let priceDesc = []
          let price = []
          let numMax = []
          if (prices) {
            for (let i in prices) {
              keysArr.push(i * 1)
              priceDesc.push(prices[i].priceDesc)
              price.push(prices[i].price / 100)
              numMax.push(prices[i].numMax)
            }
          }
          let coverUrl = ''
          let fileList = res.data.coverUrlList.map((item, index) => {
            if (index == 0) {
              coverUrl += item
            } else {
              coverUrl += ',' + item
            }
            return item
          })
          console.log('fileList', fileList)
          this.sourceFileList = fileList
          this.coverUrl = coverUrl

          //先设置动态增减表单的keys
          this.form.setFieldsValue({ keys: keysArr })
          //延时设置动态增减表单，防止渲染未完成设置失效
          setTimeout(() => {
            console.log(keysArr)
            this.form.setFieldsValue({ priceDesc, price, numMax })
          }, 100)
        })
      }
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment().endOf('day')
    },

    disabledDateTime() {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      }
    },

    disabledRangeTime(_, type) {
      if (type === 'start') {
        return {
          // disabledHours: () => this.range(0, 60).splice(4, 20),
          // disabledMinutes: () => this.range(30, 60),
          // disabledSeconds: () => [55, 56],
        }
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      }
    },
    addPrice() {
      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      console.log(keys)
      const nextKeys = keys.concat(keys.length)
      console.log(nextKeys)
      // // can use data-binding to set
      // // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys,
      })
    },
    removePrice(k) {
      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      // We need at least one passenger
      if (keys.length === 1) {
        return
      }

      // can use data-binding to set
      form.setFieldsValue({
        keys: keys.filter(key => key !== k),
      })
    },
    uploadSuccess(e) {
      console.log('e', e)
      this.coverUrlHelpTxt = ''
      let coverUrl = ''
      e.map((item, index) => {
        if (index == 0) {
          coverUrl += item.url
        } else {
          coverUrl += ',' + item.url
        }
      })
      this.coverUrl = coverUrl
    },
    getUuid() {
      return uuidv1().replace(/-/g, '')
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form.getFieldDecorator('keys', { initialValue: [0], preserve: true })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 50px 20px 30px;
  background: white;
  margin: 20px auto;
}
.ap-form {
  width: 400px;
}
.form-oper {
  text-align: center;
  button {
    margin: 0px 5px;
  }
}
</style>
